package com.schoolconnect.app.repository.parenthomework

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.feature.common.PageRequest
import kotlinx.serialization.json.JsonObject
import com.schoolconnect.app.repository.common.RepositoryCache
import com.schoolconnect.app.repository.common.tenantCacheKey
import kotlinx.coroutines.CoroutineScope

object ParentHomeworkRepository {
    private val cache = RepositoryCache<JsonObject>()
    suspend fun load(
        studentId: String?,
        status: String?,
        search: String?,
        pageIndex: Int,
        pageSize: Int,
        sortBy: String?,
        order: String?,
        refreshScope: CoroutineScope? = null
    ): Result<JsonObject> {
        val normalizedStudentId = studentId?.trim().orEmpty()
        if (normalizedStudentId.isBlank()) {
            return Result.failure(IllegalArgumentException("studentId is required for parent homework"))
        }
        val page = PageRequest(pageIndex, pageSize.coerceIn(1, 100))
        val safeSize = page.safePageSize
        val offset = page.offset
        val key = tenantCacheKey("parent-homework:$normalizedStudentId:${status.orEmpty()}:${search.orEmpty()}:$offset:$safeSize:${sortBy.orEmpty()}:${order.orEmpty()}")
        val request: suspend () -> Result<JsonObject> = {
            KtorApiClient.getParentHomework(
                studentId = normalizedStudentId,
                status = status?.trim()?.takeIf { it.isNotBlank() },
                search = search?.trim()?.takeIf { it.isNotBlank() },
                offset = offset,
                limit = safeSize,
                sortBy = sortBy,
                order = order
            )
        }
        return refreshScope?.let { scope -> cache.load(scope, "[DATA_RETRIEVE_SC] ParentHomeworkRepository", "load", key, fetch = request) } ?: request()
    }

    suspend fun loadSummary(studentId: String): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        if (normalizedStudentId.isBlank()) {
            return Result.failure(IllegalArgumentException("studentId is required for parent homework summary"))
        }
        return KtorApiClient.getParentHomeworkSummary(normalizedStudentId)
    }

    suspend fun loadDetail(homeworkId: String): Result<JsonObject> {
        val normalizedHomeworkId = homeworkId.trim()
        if (normalizedHomeworkId.isBlank()) {
            return Result.failure(IllegalArgumentException("homeworkId is required"))
        }
        return KtorApiClient.getParentHomeworkById(normalizedHomeworkId)
    }
}
